import React, { useCallback, useMemo } from 'react'
import { Button, Col, Svg } from '@tools/wr-catalog-base'
import { FiShoppingCart } from 'react-icons/fi'
import { getDuration, hasCustomizeThisPathTab, isProductPrototype } from '@utils/product-utils'
import {
  ProductBodyControlsContainer,
  ModalHeader,
  ModalBody,
  ProductCardDescription,
  ProductTypeLabel,
} from './styles'
import { CATEGORY_CLASS_NAME_MAPPING } from '../consts'
import RemoveIcon from '../../../assets/remove-icon.png'
import { ProductBadge, ProductBadgeContainer } from '../styles'

const ProductBody = ({ description, handleProductSelection, product, context, openModal, closeModal }) => {
  const isAdded = useMemo(() => context.state.cart.find((v) => v.id === product.id), [context.state.cart, product])
  const goToProductDetail = useCallback(() => {
    closeModal()
  }, [product])
  const selectProduct = useCallback(
    (e) => {
      e.preventDefault()
      e.stopPropagation()

      if (!isAdded) {
        const points = context.utils.product.getPointPrice(product)
        const hours = getDuration(product)

        handleProductSelection(product, { fullProduct: product })
        openModal({
          header: (
            <ModalHeader>
              <Col>
                <div className="title">
                  <FiShoppingCart /> Successfully Added to Proposal
                </div>
              </Col>
            </ModalHeader>
          ),
          body: (
            <ModalBody>
              <Col xs={8}>
                <h3 onClick={goToProductDetail}>{product.name}</h3>
                <p>{description}</p>
              </Col>
              <Col xs={2} align={'center'}>
                {!!points && points}
                <br />
                {!!points && 'points'}
              </Col>
              <Col xs={2} align={'center'}>
                {!!hours && hours}
                <br />
                {!!hours && 'hours'}
              </Col>
            </ModalBody>
          ),
          footer: null,
        })
      } else {
        context.actions.removeProductFromCart(product.id, product)
      }
    },
    [product, handleProductSelection, isAdded, context.actions],
  )

  const isSuccessPath = product.categories.find((c) => c.name === 'Success Paths')
  const outcome = product.rows.find((row) => row.options.tag === '<Outcome>')?.control
  const category = CATEGORY_CLASS_NAME_MAPPING.find(({ category: categoryName }) =>
    product.categories.some((category) => category.name.toLowerCase() === categoryName),
  )

  const productCategoryName = product.categories.find((cat) => category?.category === cat.name.toLowerCase())?.name

  const isPrototype = isProductPrototype(product)

  return (
    <>
      {isPrototype && (
        <ProductBadgeContainer>
          <ProductBadge>Prototype</ProductBadge>
        </ProductBadgeContainer>
      )}
      <div onClick={goToProductDetail}>
        {outcome ? (
          <ProductCardDescription as="div" dangerouslySetInnerHTML={{ __html: outcome }} />
        ) : (
          <ProductCardDescription>{description}</ProductCardDescription>
        )}
        <ProductBodyControlsContainer>
          <ProductTypeLabel>{productCategoryName}</ProductTypeLabel>
          <div className="learn-more">Learn More</div>
          <Button outline onClick={selectProduct} disabled={isSuccessPath && !hasCustomizeThisPathTab(product)}>
            {isAdded && <img src={RemoveIcon} style={{ width: '16px' }} />}
            {isAdded ? 'Remove from Proposal' : 'Add to Proposal'}
          </Button>
        </ProductBodyControlsContainer>
      </div>
    </>
  )
}

export default ProductBody
